import { DEFAULT_BASE_LAYOUT_CONFIG } from '../constants/default-layout-config'
import { BaseLayoutConfig, BASE_LAYOUT_VERSION } from '../types/base-layout'

export function resolveBaseLayoutConfig(
  config: unknown,
): BaseLayoutConfig {
  if (!config || typeof config !== 'object') {
    return DEFAULT_BASE_LAYOUT_CONFIG
  }

  const parsed = config as Partial<BaseLayoutConfig>

  if (!parsed.tabs || !Array.isArray(parsed.tabs)) {
    return DEFAULT_BASE_LAYOUT_CONFIG
  }

  return {
    version: parsed.version ?? BASE_LAYOUT_VERSION,
    tabs: parsed.tabs.map((tab, index) => ({
      id: tab?.id ?? `tab-${index}`,
      label: tab?.label ?? `Tab ${index + 1}`,
      sections: Array.isArray(tab?.sections)
        ? tab.sections.map((section, sectionIdx) => ({
            id: section?.id ?? `section-${index}-${sectionIdx}`,
            type: section?.type ?? 'custom',
            title: section?.title,
            options: section?.options,
            content: typeof section?.content === 'string' ? section.content : undefined,
          }))
        : [],
    })),
  }
}

